import React from "react";

/**
 * Quill can save visually blank paragraphs as <p><br></p>. Removing only
 * those empty blocks prevents unintended large gaps without altering real
 * article markup.
 */
function cleanRichHtml(html) {
  return String(html || "").replace(
    /<p>(?:\s|&nbsp;|<br\s*\/?\s*>)*<\/p>/gi,
    ""
  );
}

function FieldNoteDetails({ fieldNote }) {
  const media = Array.isArray(fieldNote.media) ? fieldNote.media : [];
  const galleryClassName = [
    "fieldnote-gallery",
    media.length === 1 ? "fieldnote-gallery--single" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="tab-pane fade show active package-info-tab fieldnote-content">
      <div
        className="workshop_bodytext fieldnote-body"
        dangerouslySetInnerHTML={{ __html: cleanRichHtml(fieldNote.body) }}
      />

      {media.length > 0 && (
        <div
          className={galleryClassName}
          aria-label={`Images for ${fieldNote.title}`}
        >
          {media.map((imageUrl, index) => (
            <figure className="fieldnote-gallery-item" key={`${imageUrl}-${index}`}>
              <img
                src={imageUrl}
                alt={`${fieldNote.title} by ${fieldNote.name}, image ${index + 1}`}
                loading="lazy"
              />
            </figure>
          ))}
        </div>
      )}

      <section
        className="fieldnote-biography"
        aria-labelledby="fieldnote-biography-title"
      >
        <h3 id="fieldnote-biography-title" className="d-subtitle">
          About {fieldNote.name}
        </h3>

        <div
          className="workshop_bodytext fieldnote-biography-text"
          dangerouslySetInnerHTML={{ __html: cleanRichHtml(fieldNote.biog) }}
        />

        {fieldNote.link && (
          <a
            className="fieldnote-author-link"
            href={fieldNote.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {fieldNote.link}
          </a>
        )}
      </section>
    </div>
  );
}

export default FieldNoteDetails;
